import type { RealtimeHandler } from "@/shared/realtime";

import { DRILL_SERIES_QUERY_KEY, DRILLS_OVERVIEW_QUERY_KEY } from "../api/DRILLS_QUERY_KEYS";

// `drills.ready` → из нового разбора появились задачи: значок меню, блок на главной и экран
// «На сегодня всё» перечитываются. Повтор события — ещё одна инвалидация, данные те же.
export const handleDrillsReady: RealtimeHandler<"drills.ready"> = (_event, { queryClient }) => {
  void queryClient.invalidateQueries({ queryKey: DRILLS_OVERVIEW_QUERY_KEY });
  void queryClient.invalidateQueries({ queryKey: DRILL_SERIES_QUERY_KEY });
};
